import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Switch from "react-router-dom"
import Login from "./components/Login";
import Dashboard from "./views/Dashboard";
import Account from "./views/Account";
import Home from "./views/Home";
import Map from "./views/Map";
import Trash from "./views/Trash";
import SignUp from "./views/SignUp";
import Layout from "./components/Layout";
import { Token } from "./atom/atom";
import { useRecoilValue } from "recoil";
import CreateAccount from "./views/CreateAccount";
function Urls(props, settings) {
  const isAuthenticated = useRecoilValue(Token);
  return (
    <div>
      <BrowserRouter>
        <Layout {...props}>
          <Routes>
            <Route exact path="/login" element={<Login {...props} />} />
            <Route
              exact
              path="/"
              isAuthenticated={isAuthenticated}
              element={<Home {...props} />}
            />
            <Route
              exact
              path="/home"
              isAuthenticated={isAuthenticated}
              element={<Home {...props} />}
            />
            <Route
              exact
              path="/map"
              element={<Map {...props} settings={settings} />}
            />
            <Route exact path="/map" element={<Map {...props} />} />
            <Route exact path="/signup" element={<SignUp {...props} />} />
            <Route exact path="/create-account" element={<CreateAccount {...props} />} />
            <Route
              exact
              path="/scenarios"
              isAuthenticated={isAuthenticated}
              element={<Dashboard {...props} />}
            />
            <Route
              exact
              path="/trash"
              isAuthenticated={isAuthenticated}
              element={<Trash {...props} />}
            />
            <Route
              exact
              path="/account/"
              isAuthenticated={isAuthenticated}
              element={<Account {...props} />}
            />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default Urls;
